var exports = {
  "k": "xe533113f--b1c454--container",
};

module.exports = exports;
